/**
 * Capa base Carto (antes CartoDB) para Leaflet / raster.
 * @see https://carto.com/basemaps/
 */
export const CARTO_LIGHT_TILE_URL = 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png'

export const CARTO_TILE_SUBDOMAINS = 'abcd'

/** Atribución OSM + Carto (requerida por el proveedor) */
export const CARTO_ATTRIBUTION =
  '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> ' +
  '&copy; <a href="https://carto.com/attributions">CARTO</a>'
